<template>
  <section class="hero">
    <div class="content-shell hero-inner">
      <h1>
        {{ t('hero.titleStart') }}
        <span class="hero-accent">{{ t('hero.titleAccent') }}</span>
        {{ t('hero.titleEnd') }}
      </h1>
      <p>
        {{ t('hero.subtitle') }}
      </p>
      <div class="actions">
        <v-btn
          color="primary"
          size="large"
          rounded="pill"
          :href="isAuthenticated ? '#builder' : undefined"
          @click="handleCta"
        >
          {{ isAuthenticated ? t('hero.generateNow') : t('hero.signInToTry') }}
        </v-btn>
        <v-btn
          variant="text"
          class="how-link"
          :href="isAuthenticated ? undefined : '#how-it-works'"
          @click="handleHowItWorks"
        >
          {{ t('howItWorks.link') }}
        </v-btn>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';

const props = defineProps<{
  isAuthenticated: boolean;
}>();

const { t } = useI18n();

const emit = defineEmits<{
  (event: 'sign-in'): void;
  (event: 'how-it-works'): void;
}>();

function handleCta(event: Event) {
  if (props.isAuthenticated) return;
  event.preventDefault();
  emit('sign-in');
}

function handleHowItWorks(event: Event) {
  if (!props.isAuthenticated) return;
  event.preventDefault();
  emit('how-it-works');
}
</script>

<style scoped>
.hero {
  position: relative;
  text-align: center;
  padding: 5rem 1rem 3.5rem;
  overflow: hidden;
}

.hero-inner {
  max-width: 820px;
  position: relative;
  z-index: 2;
}

h1 {
  margin: 1.2rem 0 1rem;
  font-size: clamp(2.5rem, 4.5vw, 4rem);
  line-height: 1.1;
}

.hero-accent {
  background: var(--brand-gradient);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  text-shadow: 0 0 18px var(--accent-glow);
  display: inline-block;
  margin: 0 0.3rem;
}

p {
  margin: 0 auto;
  max-width: 640px;
  color: var(--app-muted-70);
  font-size: 1.05rem;
  line-height: 1.7;
}

.actions {
  margin-top: 2rem;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 0.8rem;
}

.how-link {
  font-weight: 600;
  text-transform: none;
  color: var(--app-muted-70);
}

.how-link:hover {
  color: var(--app-text);
}

.meta {
  color: var(--app-muted-60);
  font-size: 0.95rem;
}
</style>
